export default "__VITE_ASSET__CI2m7Ttc__"